import React from 'react';
import { Link } from 'react-router-dom';
import { imageUrl } from '../lib/images';

export default function NewsCard({ item }) {
  if (!item) return null;

  const slug = item.slug?._ || item.slug || item.id;
  const image = item.hovedbillede?.[0] || item.hovedbillede || '/_assets/vtrucks.jpg';
  const title = item.titel || 'Nyhed';
  const intro = item.intro || '';
  const dateStr = item.dato ? new Date(item.dato).toLocaleDateString('da-DK', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }) : '';

  return (
    <article className="group bg-white rounded-xl overflow-hidden border border-slate-200/90 shadow-2xs hover:shadow-lg transition-all duration-200 flex flex-col h-full">
      <Link to={`/nyheder/${slug}`} className="block relative aspect-16/10 overflow-hidden bg-slate-100 focus:outline-hidden">
        <img
          src={imageUrl(image, 'width=600,quality=80,format=auto')}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        <div className="absolute top-3 right-3 bg-[#0f2b48]/90 backdrop-blur-xs text-white text-xs font-semibold px-2.5 py-1 rounded-sm shadow-xs">
          {dateStr}
        </div>
      </Link>

      <div className="p-5 sm:p-6 flex flex-col flex-1">
        <h3 className="text-lg sm:text-xl font-bold text-[#0f2b48] group-hover:text-sky-700 transition-colors line-clamp-2 mb-2">
          <Link to={`/nyheder/${slug}`} className="focus:outline-hidden">
            {title}
          </Link>
        </h3>

        {intro && (
          <p className="text-sm text-slate-600 line-clamp-3 mb-4 leading-relaxed flex-1">
            {intro}
          </p>
        )}

        <div className="pt-3 border-t border-slate-100 mt-auto">
          <Link
            to={`/nyheder/${slug}`}
            className="inline-flex items-center text-sm font-semibold text-[#0f2b48] group-hover:text-sky-700 transition-colors"
          >
            <span>Læs hele nyheden</span>
            <i className="fa-solid fa-arrow-right text-xs ml-2 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </article>
  );
}
